import api from '../api/axios';
import { PreferenciaNotificacion, Tarea } from '../types/tarea';

export const tareaService = {
  /** Lo que espera acción del usuario (entregas, revisiones, coordinar el examen…). */
  lista: async (): Promise<Tarea[]> => {
    const { data } = await api.get<{ tareas: Tarea[] }>('me/tareas/');
    return data.tareas;
  },

  /** Preferencia de notificación por correo (frecuencia + opciones). */
  notificacion: async (): Promise<PreferenciaNotificacion> => {
    const { data } = await api.get<PreferenciaNotificacion>('me/notificaciones/');
    return data;
  },

  /** Cambia la frecuencia del digest. */
  setFrecuencia: async (frecuencia: string): Promise<{ frecuencia: string }> => {
    const { data } = await api.patch<{ frecuencia: string }>('me/notificaciones/', { frecuencia });
    return data;
  },
};
